import { render, staticRenderFns } from "./Licence.vue?vue&type=template&id=3dc5ed23"
import script from "./Licence.vue?vue&type=script&lang=js"
export * from "./Licence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports